<form method="dialog" *ngIf="dialog">
    <button class="btn-close float-end"></button>
</form>

<div id="files-loading" class="mt-3" *ngIf="loading">
    <i class="fa fa-spinner fa-spin"></i>
    <span>Cargando...</span>
</div>

<div id="files" class="m-3" *ngIf="!loading">
    
    <h2>Archivos de la lección</h2>
    
    <div id="files-empty" class="mt-3" *ngIf="!upload && !hasFiles">
        <span>No hay archivos.</span>
    </div>

    <button id="files-upload-btn" class="btn btn-primary mt-3" (click)="upload = !upload">
        <div *ngIf="!upload">
            <i class="fas fa-archive"></i>
            <i class="fas fa-upload"></i>
            <span>Subir archivos</span>
        </div>
        <div *ngIf="upload">
            <i class="fas fa-archive"></i>
            <i class="fas fa-eye"></i>
            <span>Ver archivos existentes</span>
        </div>
    </button>

    <div id="files-list" class="mt-3" *ngIf="!upload && hasFiles">
        <hr>
        <p class="fw-bold"><i class="fas fa-archive"></i><span>Archivos</span></p>
        <table id="files-list-table" class="table mt-3">
            <thead>
                <tr>
                    <th>Nombre</th>
                    <th>Fecha subida</th>
                    <th>Descripción</th>
                    <th>Referencia (Copiar y pegar en el texto para insertar)</th>
                    <th>Eliminar</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let file of files; let f = index;">
                    <td>
                        {{ file.name }}
                    </td>
                    <td>
                        {{ file.time }}
                    </td>
                    <td>
                        <input type="text" [(ngModel)]="file.description">
                        <div class="mt-2">
                            <a href="#" title="Guardar descripción" (click)="editFileDesc(file)" *ngIf="!file.descSaved"> 
                                <i class="far fa-save"></i>
                                <span>Guardar</span>
                            </a>
                            <span *ngIf="file.descSaved">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Guardado!</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        <input type="text" disabled [value]="file.ref">
                        <div class="mt-2" *ngIf="clipboard">
                            <a href="#" title="Copiar referencia" (click)="copyFileRef(file)" *ngIf="!file.refCopied">
                                <i class="far fa-copy"></i>
                                <span>Copiar</span>
                            </a>
                            <span *ngIf="file.refCopied">
                                <i class="far fa-thumbs-up"></i>
                                <span>¡Copiado!</span>
                            </span>
                        </div>
                    </td>
                    <td>
                        <a href="#" title="Eliminar archivo" class="red" (click)="deleteFile(file)">
                            <i class="fas fa-times"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
        
    <div id="files-upload" *ngIf="upload">
        <div id="accepted-file-types" class="mt-3">
            <p><b>Tipos de archivo aceptados:</b> {{ acceptedTypesStr }}</p>
        </div>
        
        <div id="files-input" *ngIf="!loading">
            <p class="fw-bold">Subir archivos:</p>
            <input type="file" name="files[]" class="btn btn-primary" [accept]="acceptedTypes.join(',')" (change)="addFileToList($event)">
            <p>Tamaño máximo de archivo: 32 MB</p>
        </div>

        <div id="files-list-container" class="mx-1" *ngIf="filesToUpload.length > 0">
            <p class="fw-bold">Archivos en cola:</p>
            <ul id="files-list">
                <li *ngFor="let file of filesToUpload; let f = index;">
                    <span>{{ file.name }} ({{ file.sizeMB }} MB)</span>
                    <button class="file-remove" (click)="removeFileFromList(file)">
                        <i class="fa fa-minus"></i>
                    </button>
                </li>
            </ul>
        </div>
    
        <div id="files-upload-result">
            <div id="files-uploading" *ngIf="uploading">
                <i class="fas fa-spinner fa-spin"></i>
                <span>Subiendo...</span>
            </div>
    
            <div id="files-upload-error" class="text-danger" *ngIf="uploadError">
                <i class="fas fa-times"></i>
                <span>Ha habido un error al subir los archivos.</span>
            </div>
    
            <div id="files-upload-success" class="text-success" *ngIf="uploadSuccess">
                <i class="fas fa-check"></i>
                <span>¡Archivos subidos exitosamente!</span>
            </div>
        </div>

        <button class="btn btn-success mt-2"
            [attr.disabled]="uploading || filesToUpload.length === 0 ? 'disabled' : null"
            (click)="uploadFiles()">
            <i class="fas fa-archive"></i>
            <i class="fas fa-upload"></i>
            <span>Subir archivos</span>
        </button>

    </div>
</div>